import moment from 'moment'

function createDataSet(data) {
  for (let i = 0; i < data.columns.length; i++) {
    if (data.columns[i].type === 'date') {
      data.rows.forEach(row => {
        row[i] = moment(row[i]).toDate()
      })
    }
  }
  const dataSet = new google.visualization.DataTable()
  data.columns.forEach(item => {
    if (item.id === 'tooltip') {
      dataSet.addColumn({ type: 'string', role: 'tooltip', p: { html: true } })
    } else {
      dataSet.addColumn(item.type, item.id)
    }
  })
  dataSet.addRows(data.rows)
  return dataSet
}

function createDataSetArray(dataArray) {
  const array = []
  dataArray.forEach(item => {
    array.push(createDataSet(item))
  })
  return array
}

function mergeDataSetArray(dataSetArray) {
  let mergedData = dataSetArray[0]
  const columns = []
  for (let i = 1; i < dataSetArray.length; i++) {
    columns.push(i)
    mergedData = google.visualization.data.join(
      mergedData,
      dataSetArray[i],
      'full',
      [[0, 0]],
      columns,
      [1]
    )
  }
  return mergedData
}

function run(data) {
  const dataSetArray = createDataSetArray(data)
  const dataSet = mergeDataSetArray(dataSetArray)
  return dataSet
}

export { run }
